/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { loginLogin$Json } from '../fn/login/login-login-json';
import { LoginLogin$Json$Params } from '../fn/login/login-login-json';
import { loginLogin$Plain } from '../fn/login/login-login-plain';
import { LoginLogin$Plain$Params } from '../fn/login/login-login-plain';
import { loginValidateAndRefreshToken$Json } from '../fn/login/login-validate-and-refresh-token-json';
import { LoginValidateAndRefreshToken$Json$Params } from '../fn/login/login-validate-and-refresh-token-json';
import { loginValidateAndRefreshToken$Plain } from '../fn/login/login-validate-and-refresh-token-plain';
import { LoginValidateAndRefreshToken$Plain$Params } from '../fn/login/login-validate-and-refresh-token-plain';
import { TokenDto } from '../models/token-dto';

@Injectable({ providedIn: 'root' })
export class LoginService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `loginLogin()` */
  static readonly LoginLoginPath = '/api/Login';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loginLogin$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loginLogin$Plain$Response(params?: LoginLogin$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<TokenDto>> {
    return loginLogin$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `loginLogin$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loginLogin$Plain(params?: LoginLogin$Plain$Params, context?: HttpContext): Observable<TokenDto> {
    return this.loginLogin$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<TokenDto>): TokenDto => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loginLogin$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loginLogin$Json$Response(params?: LoginLogin$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<TokenDto>> {
    return loginLogin$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `loginLogin$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loginLogin$Json(params?: LoginLogin$Json$Params, context?: HttpContext): Observable<TokenDto> {
    return this.loginLogin$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<TokenDto>): TokenDto => r.body)
    );
  }

  /** Path part for operation `loginValidateAndRefreshToken()` */
  static readonly LoginValidateAndRefreshTokenPath = '/api/Login/validate';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loginValidateAndRefreshToken$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loginValidateAndRefreshToken$Plain$Response(params?: LoginValidateAndRefreshToken$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return loginValidateAndRefreshToken$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `loginValidateAndRefreshToken$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loginValidateAndRefreshToken$Plain(params?: LoginValidateAndRefreshToken$Plain$Params, context?: HttpContext): Observable<string> {
    return this.loginValidateAndRefreshToken$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loginValidateAndRefreshToken$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loginValidateAndRefreshToken$Json$Response(params?: LoginValidateAndRefreshToken$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return loginValidateAndRefreshToken$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `loginValidateAndRefreshToken$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loginValidateAndRefreshToken$Json(params?: LoginValidateAndRefreshToken$Json$Params, context?: HttpContext): Observable<string> {
    return this.loginValidateAndRefreshToken$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

}
